define('BayEngageReviews.Home.View', [
    'bay_engage_reviews_home.tpl',
    'Backbone',
    'jQuery'
], function (
    bay_engage_reviews_home_tpl,
    Backbone,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        template: bay_engage_reviews_home_tpl,

        initialize: function (options) {
            this.payload = options.payload || {};
            this.config = options.config || {};
            this.loader = options.loader;
        },

        afterRender: function () {
            // Ask the shared loader to inject the bundle. The PDP view will
            // make the same request; the loader coalesces them into one injection.
            if (this.loader && this.payload) {
                this.loader.load(this.payload, {
                    debugMode: this.config.debugMode,
                    containerId: this.config.containerId
                });
            }
        },

        destroy: function () {
            // Do NOT delete the entire window.brv.commonData object here — the PDP
            // view may have written product/user data that should persist until
            // the next render cycle. Only clear this view's own timers/state if
            // any are added in the future.
            if (Backbone.View.prototype.destroy) {
                Backbone.View.prototype.destroy.apply(this, arguments);
            } else if (Backbone.View.prototype.remove) {
                Backbone.View.prototype.remove.apply(this, arguments);
            }
        }
    });
});
